import { render } from "./prompt-form-button.vue?vue&type=template&id=05f95040&lang=pug"
import script from "./prompt-form-button.vue?vue&type=script&lang=js"
export * from "./prompt-form-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__